import { Component, Input, OnInit, output } from '@angular/core';
import { LoadingDirective } from '../../directives/loading.directive';
import { NgIf } from '@angular/common';
import { TranslocoModule } from '@ngneat/transloco';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-button',
    standalone:true,
    imports: [
        TranslocoModule,
        MatProgressSpinner,
        MatIconModule,
    ],
    styleUrls: ['./button.component.scss'],
    template: `
    <ng-container *transloco="let t">
      <button
        class="btn button caps-medium {{ className }}"
        [style.width]="width + '%'"
        [style.width]="widthPx + 'px'"
        [style.color]="color"
        [style.border-radius]="borderRadius"
        [style.cursor]="cursor"
        [type]="type"
        [disabled]="isDisabled || isLoading"
        (click)="onClick()"
      >
        @if(isLoading) {
        <mat-spinner class="mat-spinner" [diameter]="'32'"> </mat-spinner>
        }@else { @if(customIconLeft){
        <img width="24" height="24" [src]="customIconLeft"
          alt="customIcon"
        
        />
        }
        <span>{{ t(text) }}</span>

        @if(customIconRight){
        <img
          [style.width]="customIconRightWidth + 'px'"
          [style.height]="customIconRightHeight + 'px'"
          [src]="customIconRight"
          alt="customIcon"
        />
        } @if(icon){
        <mat-icon>{{ icon }}</mat-icon>
        } }
      </button>
    </ng-container>
  `
})
export class ButtonComponent implements OnInit {
  @Input() text: string;
  @Input() color: string = 'primary';
  @Input() className: string = '';

  @Input() isDisabled: boolean;
  @Input() type: string = 'button';
  @Input() customIconRightWidth: string = '40';
  @Input() customIconRightHeight: string = '40';
  @Input() width: string = '100';
  @Input() widthPx: string = '';
  @Input() borderRadius: string = 'none';
  @Input() icon!: string;
  @Input() isLoading: boolean | null = false;
  @Input() cursor: string;
  @Input() customIconLeft!: string;
  @Input() customIconRight!: string;

  btnClick = output<void>();

  ngOnInit(): void {}

  onClick() {
    this.btnClick.emit();
  }
}
